import { map } from 'rxjs/operators';
import { API_URL } from 'consts/common.const';
import { Http, Response } from 'services/http';

interface PartnerItem {
  label: string;
  value: number;
}

export const getPartner = () => {
  return Http.request({
    method: 'GET',
    url: `${API_URL}/common/pulldown/partner`,
  }).pipe(
    map((res: Response<Array<Array<any>>>) => {
      const newData: PartnerItem[] = res.data.map((item) => ({
        label: item[1],
        value: item[0],
      }));

      return newData;
    })
  );
};
